module.exports = __webpack_public_path__ + "static/img/service-QR-code.a6608f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/service-QR-code.png
// module id = We4L
// module chunks = 1